import { Component, createNgModule, Injector, OnInit, EventEmitter, Input, ViewChildren, Output, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { JwtAuthService } from '../../services/auth/jwt-auth.service';
import { EgretNotifications2Component } from '../egret-notifications2/egret-notifications2.component';
import { DataOrderService, OrderDetail } from 'app/shared/services/data-order.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { isSearchableTerm } from './search-term.util';
import { UntypedFormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { PortalSettingsService } from 'app/shared/services/portal-settings.service';
import { ShiftButtonComponent } from '../shift-button/shift-button.component';
import { AlertService } from 'app/shared/services/alert/alert.service';
import { ShiftAssignStatusEnum } from 'app/shared/helpers/status-options.helper';
import { Router } from '@angular/router';
import { ClipboardService } from 'app/shared/services/clipboard.service';

@Component({
    selector: 'app-header-side',
    templateUrl: './header-side.template.html',
    standalone: false
})
export class HeaderSideComponent implements OnInit {
  @ViewChild(ShiftButtonComponent) shiftButtonComponent: ShiftButtonComponent;
  @Input() isShiftAvailable: string;
  @Input() notificPanel;
  @ViewChildren(EgretNotifications2Component) noti;
  @ViewChild('searchInput') searchInput: ElementRef
  username: string = '';
  password: string = '';
  shiftStatus: ShiftAssignStatusEnum;
  isProcessing: boolean = false;

  public availableLangs = [{
    name: 'EN',
    code: 'en',
    flag: 'flag-icon-us'
  }, {
    name: 'ES',
    code: 'es',
    flag: 'flag-icon-es'
  }];
  loading: boolean = false
  currentLang = this.availableLangs[0];
  thing: Observable<any>
  termType = 'uniqueorderid'
  searchTermControl = new UntypedFormControl()
  searchOrderResults: OrderDetail['orderData'][] = [];
  focused = false
  logo = 'assets/images/logomain.png';

  public egretThemes;
  public layoutConf: any;
  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public translate: TranslateService,
    private renderer: Renderer2,
    public jwtAuth: JwtAuthService,
    private ordersService: DataOrderService,
    private portalSettingsService: PortalSettingsService,
    private alertService: AlertService,
    private router: Router,
    private clipboardService: ClipboardService,
    private dialog: MatDialog,
    private injector: Injector
  ) { }
  ngOnInit() {
    this.portalSettingsService.portalSettings.subscribe(data => {
      this.logo = data.logo
    })
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    this.translate.use(this.currentLang.code);

    this.searchTermControl.valueChanges.pipe(
      distinctUntilChanged(),
      tap(term => {
        if (!isSearchableTerm(term)) {
          this.searchOrderResults = [];
          this.loading = false;
        } else {
          this.loading = true;
        }
      }),
      debounceTime(650),
      switchMap(term => {
        if (!isSearchableTerm(term)) {
          return EMPTY;
        }
        const params = {
          searchterm: term,
          status: 'All'
        };
        return this.ordersService.getAllOrders(params).pipe(
          catchError(_ => {
            this.searchOrderResults = [];
            this.loading = false;
            return [];
          })
        );
      })
    ).subscribe({
      next: res => {
        this.searchOrderResults = res.Msg ? [] : (res[0]?.data || []);
        this.loading = false;
      },
      error: _ => {
        this.searchOrderResults = [];
        this.loading = false;
      }
    });

  }


  async openTwoFactorAuth() {
    if (this.jwtAuth.isDriver()) {
      this.router.navigateByUrl('/driver/coming-soon');
      return;
    }
    if (this.router.url === '/security/two-factor-auth' || this.dialog.getDialogById('two-factor-auth')) {
      return;
    }
    const { SecurityModule } = await import('../../../views/security/security.module');
    const { TwoFactorAuthComponent } = await import('../../../views/security/two-factor-auth/two-factor-auth.component');
    if (this.router.url === '/security/two-factor-auth' || this.dialog.getDialogById('two-factor-auth')) {
      return;
    }
    const moduleRef = createNgModule(SecurityModule, this.injector);
    const dialogRef = this.dialog.open(TwoFactorAuthComponent, {
      id: 'two-factor-auth',
      width: '560px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      ariaLabel: 'Two-Factor Authentication',
      closeOnNavigation: false,
      injector: moduleRef.injector,
    });
    dialogRef.afterClosed().subscribe(() => moduleRef.destroy());
  }

  copyToClipboard(value: string, fieldName: string): void {
    this.clipboardService.copyToClipboard(value, fieldName);
  }

  handleRemoteDesktopCredentials(credentials: { username: string; password: string; status?: ShiftAssignStatusEnum }) {
    this.shiftStatus = credentials.status;
    this.username = credentials?.username ?? '';
    this.password = credentials?.password ?? '';
  }


  refreshPage() {
    if (this.shiftButtonComponent) {
      this.shiftButtonComponent.getShiftStatus();
    }

    const event = new CustomEvent('refreshOrders');
    window.dispatchEvent(event);

  }

  setLang(lng) {
    this.currentLang = lng;
    this.translate.use(lng.code);
  }
  changeTheme(theme) {
    // this.themeService.changeTheme(theme);
  }
  toggleNotific() {
    this.notificPanel.toggle();
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full'
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed'
    });
  }

  getUserDisplayName() {
    return this.jwtAuth.getUser()?.displayName
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
        sidebarCompactToggle: false
      }, { transitionClass: true });
    }

    // * --> compact
    this.layout.publishLayoutChange({
      sidebarStyle: 'compact',
      sidebarCompactToggle: true
    }, { transitionClass: true });

  }
  selectHandler(event: MatAutocompleteSelectedEvent): void {
    this.searchInput.nativeElement.value = '';
    this.searchInput.nativeElement.blur();
    this.searchOrderResults = [];
    this.searchTermControl.reset();
  }

  shouldDisplayNoResultsMessage(): boolean {
    return (
      this.searchOrderResults?.length === 0 &&
      this.focused &&
      isSearchableTerm(this.searchTermControl.value) &&
      !this.loading
    );
  }

  switchToAdminView(): void {
    this.router.navigate(['/clinician/profiles']).then(() => {
      window.location.reload();
    });
    this.jwtAuth.switchToAdminView();
  }

  triggerOrdersAutoAllocation() {
    this.isProcessing = true;
    this.ordersService.triggerOrdersAutoAllocation().subscribe({
      next: (res) => {
        this.isProcessing = false;
        this.refreshPage();
        this.alertService.notifySuccess(res.msg);
      },
      error: () => {
        this.isProcessing = false;
        this.alertService.notifyError('Failed to auto-allocate orders. Please try again.');
      }
    });
  }
}
